import {APP_CONFIG} from "../config";
import {axios} from '../bootstrap';

export default {
    /*
        GET
     */
    getAll(page) {
        return axios.get(APP_CONFIG.URL+"products?page="+page);
    },

    find(id) {
        return axios.get(APP_CONFIG.URL+"products/"+id);
    },

    create(payload){
        return axios.post(APP_CONFIG.URL+"products", payload);
    },

    update(payload){
        return axios.patch(APP_CONFIG.URL+"products/"+payload.id, payload);
    },

    delete(id){
        return axios.delete(APP_CONFIG.URL+"products/"+id);
    }
}
